import { axiosInstanceOpen } from "../host";

export const HttpRequestHubOpen = (config: any) => {
  return axiosInstanceOpen(config);
};
